module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f074fe_logo_200x200.d7f01a72.png";